import { isToolbarHeaderActive } from './ToolbarStore';

export const updateToolbarHeader = (value) => isToolbarHeaderActive.update((oldValue) => value);
